<template>
    <div id="DmhFaqItem">
      <button class="faq-item d-flex flex-row align-items-start shadow clickable animate__animated w-100 text-left border-0" @click="open()" v-if="!opened">
        <div class="pr-4">
                <p v-if="index === 0" class="best-match-label">Best match</p>
                <h3 class="faq-item-title">{{ item.title ? item.title : item.question }}</h3>
                <p class="faq-item-excerpt" v-if="!opened">{{ item.excerpt ? item.excerpt : item.answer }}</p>
                <p class="faq-item-excerpt brand-text" v-else v-html="decode(item.content)"></p>
            </div>
            <div class="faq-icon-container">
              <i class="fa-solid fa-angle-right brand-light"></i>
            </div>
        </button>
        <div class="faq-article-item" v-else >
            <h2 class="faq-item-title brand-text">{{ item.title ? item.title : item.question }}</h2>
            <div class="faq-item-content" v-html="decode(item.content)"></div>
            <div class="mb-4 d-flex justify-content-end">
                <b-button   @click="open()" variant="cta-outline" class="btn-lg">Close</b-button>
            </div>
        </div>
    </div>
</template>
  
<script>

export default {
    name: "DmhFaqItem",
    props: ['item', 'type', 'index'],
    components: {
    },
    mounted() { },
    data() {
        return {
            opened: false,
        };
    },
    mounted() {
    },
    methods: {
        decode(data) {
            try {
                // console.log(decodeURIComponent(escape(Buffer.from(data, "base64"))));
                return decodeURIComponent(escape(Buffer.from(data, "base64")));
            } catch (err) {
                try{
                    // console.log(unescape(Buffer.from(data, "base64")));
                    return unescape(Buffer.from(data, "base64"))
                }catch(e){
                    console.log(e)
                }
                console.log(err);
            }
        },
        open() {
            this.opened = !this.opened;
        }
    },
    computed: {
    },
};
</script>
<style lang="less">
#DmhFaqItem {
    display: flex;
    flex-direction: row;
    flex-grow: 1;

    .best-match-label {
      font-family: "PlusJakartaSansBold";
      font-size: 1.2rem;
      color: #3C16F9;
      margin-bottom: 12px;
    }
    .faq-item {
        flex: 1;
        flex-grow: 1;
        background-color: white;
        padding: 24px;
        margin-bottom: 30px;
        border-radius: 12px;
        min-width: 100%;
        max-width: 600px;

        .faq-icon-container {
            height: 100%;
            width: 40px;
            display: flex;
            align-items: center;
            justify-content: center;

            i {
                font-size: 2.2rem;
            }

        }

        .faq-item-title {
            margin-bottom: 8px;
            padding: 0 !important;
            text-align: left;
            font-size: 1.6rem;
            letter-spacing: 0;
            font-family: "PlusJakartaSansBold";
        }

        .faq-item-excerpt {
            width: 100%;
            flex-grow: 1;
            font-size: 1.4rem;
            font-family: "PlusJakartaSansRegular";
            padding: 0;
            margin: 0;

        }
        
    }
    .faq-article-item {
        border-radius: 12px;
        padding: 24px;
        .faq-item-title{
            margin-bottom: 16px;
            text-align: left;
            letter-spacing: 0;
            font-family: "PlusJakartaSansBold";
            font-size: 2.2rem;
        }
    }
    .faq-item-content{
        font-family: "PlusJakartaSansRegular";
        font-size: 1.6rem;
        padding-bottom: 20px;

        h1,h2,h3,h4,h5,h6{
            letter-spacing: normal;
            font-family: "PlusJakartaSansBold";
            text-align: left;
            font-size: 2.2rem;
            color: inherit;
            
        }
        p{
            margin-bottom: 20px;
            color: inherit;
        }
        img{
            max-width: 100%;
        }
        div{
            color: inherit;
        }
    }
}
</style>
  